var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-3/4 inline-block clear-both",class:{
    'float-right text-right': _vm.item.me,
    'float-left': !_vm.item.me,
  }},[_c('div',{staticClass:"p-4 mt-4 shadow-md text-left rounded-xl text-black text-messengerBase",class:{
      'bg-yellow': _vm.item.me,
      'bg-white': !_vm.item.me,
    }},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content)}})]),_c('div',{staticClass:"text-gray mt-2",staticStyle:{"font-size":"10px"}},[_vm._v(_vm._s(_vm.item.time))])])}
var staticRenderFns = []

export { render, staticRenderFns }